import { render, staticRenderFns } from "./FormFloor.vue?vue&type=template&id=64177ef6&"
import script from "./FormFloor.vue?vue&type=script&lang=js&"
export * from "./FormFloor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports